var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "birthday_nav_auto_inner" },
    _vm._l(_vm.value.config.value, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "item",
          style: {
            width: "calc((100% - 5px) / " + _vm.value.config.value.length + ")",
          },
        },
        [
          _c(
            "el-image",
            {
              staticStyle: { width: "100%", height: "100%" },
              attrs: { src: item.small_imageurl },
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-slot",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [_c("i", { staticClass: "el-icon-picture" })]
              ),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }